export const DEFAULT_BEAMLINES = 'SOLEIL'
export const EXI_APP_BASE_NAME = '/EXI2'
